import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';

import { ChartWrapper } from 'src/components';
import { eeccCategoriesMapper } from 'src/utils/eeccCategoriesMapper';


const categoryList = Object.entries(eeccCategoriesMapper).map(([ symbol, data ]) => ({ ...data, symbol }));

const EeccCondensed = ({ eeccs, eeccTypeFilter }) => {

  const chartDataByType = useMemo(() => {
    const grouped = eeccs.groupedEecc || {};
    const result = {};
    Object.keys(grouped).forEach(type => {
      result[type] = {
        labels: categoryList.map(c => c.text),
        datasets: [
          {
            data: categoryList.map(c => grouped[type]?.[c.symbol] || 0),
            backgroundColor: categoryList.map(c => c.backgroundColor),
          },
        ],
      };
    });
    return result;
  }, [ eeccs ]);

  const options = useMemo(() => ({
    plugins: {
      tooltip: {
        callbacks: {
          label: context => {
            const symbol = categoryList[context.dataIndex].symbol;
            const text = categoryList[context.dataIndex].text;
            const value = context.parsed;
            return `${symbol} - ${text}: ${value}`;
          },
          labelColor: context => ({
            borderColor: categoryList[context.dataIndex].backgroundColor,
            backgroundColor: categoryList[context.dataIndex].backgroundColor,
          }),
        },
      },
      legend: {
        labels: {
          generateLabels: chart => {
            const data = chart.data;
            return data.labels.map((label, i) => ({
              text: `${categoryList[i].symbol} - ${label}`,
              fillStyle: data.datasets[0].backgroundColor[i],
              strokeStyle: data.datasets[0].backgroundColor[i],
              lineWidth: 1,
              hidden: isNaN(data.datasets[0].data[i]) || chart.getDatasetMeta(0).data[i].hidden,
              index: i,
            }));
          },
        },
      },
    },
  }), []);

  return (
    <Box display="flex" justifyContent="center" alignItems="center" height={400}>
      <ChartWrapper type="pie" options={options} data={chartDataByType[eeccTypeFilter]} />
    </Box>
  );
};

EeccCondensed.propTypes = {
  eeccs: PropTypes.object,
  eeccTypeFilter: PropTypes.string,
};


export { EeccCondensed };